// src/components/ChartMap.js
import ChartClientOrder from './ChartClientOrder';
import ChartRevenue from './ChartRevenue';
import ChartOrderStatus from './ChartOrderStatus';
import ChartOrderAmountDistribution from './ChartOrderAmountDistribution';
import ChartClientRevenue from './ChartClientRevenue';
import ChartProductSales from './ChartProductSales';
import ChartProductVariantSales from './ChartProductVariantSales';
import ChartUnitPrice from './ChartUnitPrice';
import ChartAvgOrderByDiscount from './ChartAvgOrderByDiscount';
import ChartOrderCountByDiscount from './ChartOrderCountByDiscount';
import ChartSalesByDiscount from './ChartSalesByDiscount';
import ChartCategorySales from './ChartCategorySales';
import ChartPriceRangeSales from './ChartPriceRangeSales';
import ChartStockHistory from './ChartStockHistory';
import ChartIndustryWiseClientCount from './ChartIndustryWiseClientCount';

export const chartMap = {
    clientOrder: { component: ChartClientOrder, label: '顧客別注文数', slug: 'client-order' },
    revenue: { component: ChartRevenue, label: '売上高の推移', slug: 'revenue' },
    orderStatus: { component: ChartOrderStatus, label: '現在の注文状況', slug: 'order-status' },
    orderAmountDistribution: { component: ChartOrderAmountDistribution, label: '注文金額の分布', slug: 'order-amount-distribution' },
    clientRevenue: { component: ChartClientRevenue, label: '顧客別注文売上高', slug: 'client-revenue' },
    productSales: { component: ChartProductSales, label: '商品別売上高・販売数量（上位30件）', slug: 'product-sales' },
    variantSales: { component: ChartProductVariantSales, label: '品番別売上高（上位30件）', slug: 'variant-sales' },
    unitPrice: { component: ChartUnitPrice, label: '単価別分析', slug: 'unit-price' },
    //avgOrderByDiscount: { component: ChartAvgOrderByDiscount, label: '割引率別平均注文金額', slug: 'avg-order-by-discount' },
    //orderCountByDiscount: { component: ChartOrderCountByDiscount, label: '割引率別注文数', slug: 'order-count-by-discount' },
    //salesByDiscount: { component: ChartSalesByDiscount, label: '割引率別売上高', slug: 'sales-by-discount' },
    categorySales: { component: ChartCategorySales, label: '商品カテゴリ別売上', slug: 'category-sales' },
    priceRangeSales: { component: ChartPriceRangeSales, label: '価格帯別売上', slug: 'price-range-sales' },
    stockHistory: { component: ChartStockHistory, label: '在庫変動履歴', slug: 'stock-history' },
    industryClientCount: { component: ChartIndustryWiseClientCount, label: '業種別顧客数', slug: 'industry-client-count' },
};
